/**
 * Market making management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface MarketMakingRoute {
  id?: number;
  pairSettingId?: number;
  pairId?: number;
  priority?: number;
  wideBps?: number;
  crossPairId?: number;
  secondLegSettingId?: number;
  eventDetection?: boolean;
  priceConstruction?: boolean;
  execution?: boolean;
}
